import { Empresa } from './empresa';
import { Serializable } from './commom/serializable';

export class Usuario implements Serializable<Usuario> {
    public Id: number;
    public NomeUsuario: string;
    public Senha: string;
    public Perfil: string;
    public Nome: string;
    public Ativo: string;
    public Empresa: Empresa;

    deserialize(input: Object): Usuario {
        Object.assign(this, input);

        return this;
    }
}


// WEBPACK FOOTER //
// ./src/entities/usuario.ts